module.exports = __webpack_public_path__ + "static/media/Cart.f5c3ec32.png";